import { render, staticRenderFns } from "./QuestionModal.vue?vue&type=template&id=7808494a&scoped=true&"
import script from "./QuestionModal.vue?vue&type=script&lang=js&"
export * from "./QuestionModal.vue?vue&type=script&lang=js&"
import style0 from "./QuestionModal.vue?vue&type=style&index=0&id=7808494a&prod&scoped=true&lang=css&"
import style1 from "./QuestionModal.vue?vue&type=style&index=1&id=7808494a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7808494a",
  null
  
)

export default component.exports